//import logo from './logo.svg';
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
 // BrowserRouter
} from "react-router-dom";
import Header from './components/header/header';
import Footer from './components/footer/footer';
import Homepage from './components/homepage/homepage';
//import Reports from './components/reports1/reports1';
import Login from './components/login/login';
import CallbackLoginGov from './components/callback/CallbackLoginGov';
import CallbackMyAccess from './components/callback/CallbackMyAccess';
import DriverDetails from './components/driver/details';
import AddConvictions from './components/driver/addConvictions';
import AddWithdrawal from './components/driver/addWithdrawal';
import NoDriverConviction from './components/driver/noDriverConviction';
import Helpcontact from './components/forms/helpContact';
import QueryMX from './components/tabs/queryMX';
import { AuthProvider, useAuth } from './context/AuthContext';
import EditDriver from './components/driver/EditDriver';
import HelpDeskDriverDetails from './components/driver/helpDeskDetails';
import { useEffect, useState } from 'react';
import UpdateWithdrawal from './components/driver/updateWithdrawal';
import UpdateConviction from './components/driver/updateConviction';
import AddStagingWithdrawal from './components/driver/addStagingWithdrawal';
import UpdateStageWithdrawal from './components/driver/updateStageWithdrawal';
import Reports from './components/tabs/reports';
import { Modal } from 'react-bootstrap';
import Messages from './components/tabs/ReportFiles/messages';
import { AlertProvider, useAlerts } from './context/AlertContext';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
function AppContent() {
  const { isAuthenticated, logout } = useAuth();
  const [showWarning, setShowWarning] = useState(false);
  const [countdown, setCountdown] = useState(120); // 2 minutes
  const { alertMessages, setAlerts, setMaintenance } = useAlerts();
  const location = useLocation();

  useEffect(() => {
  async function fetchData() {
      try {
        const response = await fetch('/api/banner/getmessages');
        if (!response.ok) throw new Error('Failed to fetch');
        const data = await response.json();

        console.log("Fetched banner data:", data);

        setAlerts(data?.responseData?.alert?.fcwd || []);
        setMaintenance(data?.responseData?.maintenance?.fcwd || []);
      } catch (error) {
        console.error("Error fetching banner:", error);
      }
    }
    if (location.pathname === '/') {
      fetchData();
    }
  }, [location.pathname]);

  useEffect(() => {
    let logoutTimer, warningTimer, countdownTimer;

    const resetTimer = () => {
      setShowWarning(false);
      clearTimeout(logoutTimer);
      clearTimeout(warningTimer);
      clearInterval(countdownTimer);

      // Show modal at 13 minutes
      warningTimer = setTimeout(() => {
        setShowWarning(true);

        // Start countdown for 2 mins
        setCountdown(120);
        countdownTimer = setInterval(() => {
          setCountdown(prev => {
            if (prev <= 1) {
              clearInterval(countdownTimer);
            }
            return prev - 1;
          });
        }, 1000);
      }, 13 * 60 * 1000); // 13 minutes

      // Logout at 15 minutes
      logoutTimer = setTimeout(() => {
        setShowWarning(false);
        logout();
      }, 15 * 60 * 1000);
    };

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keydown', resetTimer);
    resetTimer();

    return () => {
      clearTimeout(logoutTimer);
      clearTimeout(warningTimer);
      clearInterval(countdownTimer);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keydown', resetTimer);
    };
  }, [isAuthenticated, logout]);
  return (
    <>
      <Header />
      <body className="container-fluid" id='App-body'>
      {alertMessages && alertMessages.length > 0 && 
      <div class="alert alert-danger" role="alert">
        {alertMessages.map((message) => (
          <div>
            <strong>{message}</strong>
          </div>
        ))}
      </div>
      }
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/logindotgov/authorization-code/callback" element={<CallbackLoginGov />} />
        <Route path="/myaccess/authorization-code/callback" element={<CallbackMyAccess />} />
        {/* <Route path="/about" element={<About />} /> */}
        <Route path="/" element={<Homepage />} />
        <Route path="/driver/:jurisdiction/:license/:fcOnly" element={<DriverDetails />} />
        <Route path="/driverdetails/:jurisdiction/:license" element={<DriverDetails />} />
        <Route path="/canadadetails/:jurisdiction/:license/:lastname/:firstname/:dob" element={<DriverDetails />} />
        <Route path="/canadadetails/:jurisdiction/:license/:lastname/:dob" element={<DriverDetails />} />
        <Route path="/driverdetails/helpdesk/:jurisdiction/:license" element={<HelpDeskDriverDetails />} />
        <Route path="/addconviction/:jurisdiction/:license/:help" element={<AddConvictions />} />
         <Route path="/addconviction/:jurisdiction/:license" element={<AddConvictions />} />
        <Route path="/updateconviction/:jurisdiction/:license/:id/:acd/:cdl/:disable/:n" element={<UpdateConviction />} />
        <Route path="/addwithdrawal" element={<AddWithdrawal />} />
        <Route path="/staging/addwithdrawal" element={<AddStagingWithdrawal />} />
        <Route path="/updatewithdrawal" element={<UpdateWithdrawal />} />
        <Route path="/staging/updatewithdrawal" element={<UpdateStageWithdrawal />} />
        <Route path="/contact" element={<Helpcontact />} />
         <Route path="/reports" element={<Reports />} />
        <Route path="/noDriverConviction/:jurisdiction/:license" element={<NoDriverConviction />} />
        <Route path="/queryMX/:country/:license" element={<QueryMX />} />
        <Route path="/editdriver" element={<EditDriver />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/messages" element={<Messages />} />
        {/* <Route path="/logindotgov/authorization-code/callback" element={<CallbackLoginGov />} />
        <Route path="/myaccess/authorization-code/callback" element={<CallbackMyAccess />} /> */}
        {/* <Route path="*" element={<NotFound />} /> */}snip
        
      </Routes>
      </body>
      <Footer /> {/* Conditionally render the Footer */}
      
      <Modal show={showWarning} onHide={() => setShowWarning(false)} centered>
        <Modal.Header>
          <Modal.Title>Session Timeout Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          You will be logged out due to inactivity in <strong>{countdown}</strong> seconds.
          Please move your mouse to remain logged in.
        </Modal.Body>
      </Modal>
    </>
  );
} 

export default function App() {
  return (
    <Router>
       <AuthProvider>
        <AlertProvider>
          <ScrollToTop />
          <AppContent />
        </AlertProvider>
      </AuthProvider>
    </Router>
  );
}
